module.exports = __webpack_public_path__ + "static/media/click.fbfef086.png";